export default "__VITE_ASSET__D3O$9eMD__"